/*
 * Project: LegalPlace assistant
 * File: src\components\variable.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


// variable renderer
import React, { Component } from 'react';
import { SOptionType } from '../logic/lp_map_utils';
import { generateId1 } from './utils/misc';
// importing basic componentns
import LpSingleText from './misc/static';
import LpSingleRadio from './misc/radio';
import LpSingleHidden from './misc/hidden';
import LpText from './misc/text';
import LpList from './misc/list';
import LpCheckBox from './misc/checkbox';
import LpTextArea from './misc/textarea';
import LpEval from './misc/eval';
import LpNumber from './misc/number';
import LpDatePicker from './misc/date';
import LpPure from './misc/pure';
import lpApp from '../app/lp_app';
import LpBasicMask from './misc/basic_mask';
import LpAdvancedMask from './misc/advanced_mask';

const flen = {
  width: '100%',
};

export default class Variable extends Component {
  constructor(props) {
    super(props);
    // get type
    const defaults = {
      id: -1,
      parent: -1,
      key: generateId1(3),
      lpKey: generateId1(4),
      // lpParent
      label: '',
      type: SOptionType.NONE,
      font_size: 16,
      helper: '',
      is_multiple: false,
      isDuplicate: false,
      copy: generateId1(2),
    };
    this.params = Object.assign(defaults, props);
  }

  componentDidMount() {
  }

  render() {
    let result;
    // console.log(this.props)
    switch (this.props.type) {
      case SOptionType.HIDDEN:
      case 'hidden':
        result = (<LpSingleHidden
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          ovc="v"
          value=""
          isDuplicate={this.props.isDuplicate}
          is_multiple={this.props.is_multiple}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.STATIC:
      case 'static':
        result = (<LpSingleText
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.RADIO:
      case 'radio':
        result = (<LpSingleRadio
          lpKey={this.props.lpkey}
          key={generateId1(1)}
          group={this.props.parent}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.CHECKBOX:
      case 'checkbox':
        result = (<LpCheckBox
          lpKey={this.props.lpKey ? this.props.lpKey : generateId1(4)}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.TEXT:
      case SOptionType.HOUR:
      case SOptionType.EMAIL:
      case 'text':
      case 'hour':
      case 'email':
        result = (<LpText
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          autocomplete={this.props.autocomplete}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.EVAL:
      case 'eval':
        result = (<LpEval
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.NUMBER:
      case 'number':
        result = (<LpNumber
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.LIST:
      case 'list':
        result = (<LpList
          lpKey={this.props.lpKey}
          key={generateId1(4)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.TEXTAREA:
      case 'textarea':
        result = (<LpTextArea
          lpKey={this.props.lpKey}
          key={generateId1(4)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.DATE:
      case 'date':
        result = (<LpDatePicker
          lpParent={this.props.lpParent}
          parent={this.props.parent}
          lpKey={this.props.lpKey}
          key={generateId1(4)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
        />);
        break;
      case SOptionType.PURE:
      case 'brut-text':
        result = (<LpPure
          id={this.props.id}
          content={lpApp.references.getOption(this.props.id).meta.content}
          isDuplicate={this.props.isDuplicate}
          copy={this.props.copy}
        />);
        console.log('Pure');
        break;
      case SOptionType.BASICMASK:
      case 'mask':
        result = (<LpBasicMask
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          autocomplete={this.props.autocomplete}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      case SOptionType.ADVANCEDMASK:
      case 'advancedmask':
        result = (<LpAdvancedMask
          lpKey={this.props.lpKey}
          key={generateId1(1)}
          id={this.props.id}
          label={this.props.label}
          ovc="v"
          is_multiple={this.props.is_multiple}
          isDuplicate={this.props.isDuplicate}
          autocomplete={this.props.autocomplete}
          copy={this.props.copy}
          parent={this.props.parent}
        />);
        break;
      default:
        result = (<div />);
        break;
    }

    // console.log(this.props.label + " => " + this.props.awlad);
    if (lpApp.ops.two_steps.checkVariable(this.props.id)) return (<div />);
    return (<div className={`input-field${!lpApp.ops.two_steps.isDiscovered(this.props.id, 'variable') ? ' highlight-second' : ''}`} style={flen} data-type="variable-single" data-id={this.props.id} data-is-duplicate={this.props.isDuplicate} data-copy={this.props.copy}>

      { result }

    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/variable.js